<template>
  <div class="sonsFlexEvent">
    <div class="flexList">
      <div class="flexListTop">
        <p>充值申请记录</p>
        <!-- <div>
          <DatePicker
            :open="open"
            :value="value3"
            placement="left-start"
            type="month"
            @on-change="handleChange">
            <a href="javascript:void(0)" @click="handleClick">
                <i class="iconfont icon-rili" :show="show" v-if="value3 === ''"></i>
                <template v-if="value3 === ''"></template>
                <template v-else>{{ value3 }}</template>
            </a>
          </DatePicker>
        </div> -->
      </div>
      <div class="Content">
        <Table  :columns="ContentListColumns" :data="upDataListNumber" :loading="loading"></Table>
      </div>
    </div>
  </div>
</template>

<script type="text/jsx">
import { Button, Dropdown, Icon, DropdownMenu } from 'iview';
import MemberAudit from '../MemberAudit.vue';
import AddAccountsDetails from '../AddAccountsDetails.vue';
import AddAccounts from '../AddAccounts.vue';
export default {
  name: 'EcoinList',
  props: {
    upDataListNumber: Array,
    loading: Boolean
  },
  data () {
    return {
      open: false,
      value3: '',
      show: true,
      ContentListColumns: [
        {
          title: '付款人',
          key: 'name'
        },
        {
          title: '收款人',
          key: 'receiver'
        },
        {
          title: '充值金额',
          render: (h, params) => {
            return (
              <div>
                {
                  params.row.payAmount + '元'
                }
              </div>
            )
          }
        },
        {
          title: '用途',
          key: 'useInfo'
        },
        {
          title: '转账日期',
          key: 'checkTime'
        },
        {
          title: '状态',
          key: 'statusName'
        },
        {
          title: '创建信息',
          key: 'renark',
          render: (h, params) => {
            return (
              <div>
                <p>{ params.row.createUser }</p>
                <p>{ params.row.createTime }</p>
              </div>
            )
          }
        },
        {
          title: '操作',
          render: (h, params) => {
            return (
                <Dropdown>
                  操作<Icon type="ios-arrow-down"/>
                  <DropdownMenu slot="list">
                    <AddAccountsDetails type={'0'} v-show={params.row.status !== '0'} row={params.row} on-onChange={this.change}>
                      <li>查看</li>
                    </AddAccountsDetails>
                    <AddAccounts type={'0'} v-show={params.row.status === '0' || params.row.status === '3' || params.row.status === '4'} row={params.row} on-onChange={this.change}>
                      <li>修改</li>
                    </AddAccounts>
                    <li v-show={params.row.status === '0' || params.row.status === '4'} onClick={() => this.memberAudit(params.row)}>提交</li>
                    <MemberAudit row={params.row} on-Change={this.change} v-show={params.row.status === '1'}>
                      <li>撤回申请</li>
                    </MemberAudit>
                  </DropdownMenu>
                </Dropdown>
            )
          }
        }
      ]
    }
  },
  methods: {
    // <li v-show={params.row.status === '0' || params.row.status === '3'}>删除</li>
    handleClick () {
      this.open = !this.open;
    },
    handleChange (date) {
      this.value3 = date;
      this.open = false
      this.$emit('on-change', this.value3);
    },
    change () {
      this.$emit('on-change')
    },
    memberAudit (row) {
      let that = this;
      that.$Modal.confirm({
        title: '提交充值申请审核',
        content: `确认要提交充值申请审核吗？`,
        onOk () {
          this.$get(`/memberAudit/memberAudit?applyId=${row.id}&type=KHXXCZSP`).then(res => {
            if (res.success) {
              that.$emit('on-change')
            }
          })
        }
      })
    },
    Receive (e) {
      this.$get(`/receive/coin?id=${e}`).then((res) => {
        this.$emit('on-change');
        this.$emit('onChange');
      })
    }
  }
}
</script>

<style lang="less">
  .sonsFlexEvent{
    width: 100%;
    margin-top: 30px;
    .flexList{
      .flexListTop{
        width: 100%;
        height: 39px;
        border: 1px solid #e5e5e5;
        background: #f4f5f9;
        display: flex;
        justify-content: space-between;
        border-bottom: none;
        p{
          font-size: 14px;
          text-indent: 20px;
          line-height: 39px;
        }
        div{
          line-height: 39px;
          margin-right: 15px;
        }
      }
      .Content{
        .ivu-dropdown-menu{
          li{
            text-align: center;
            padding: 5px;
            cursor: pointer;
            &:hover{
              background: #f3f3f3;
            }
          }
        }
      }
    }
  }
</style>
